"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./FilterFlags.css");
var player_tag_1 = require("player-tag");
var csod = require("player-core");
var FilterFlags = (function (_super) {
    __extends(FilterFlags, _super);
    function FilterFlags(props) {
        return _super.call(this, props) || this;
    }
    FilterFlags.prototype.render = function () {
        var _this = this;
        var listOfFlags = null;
        listOfFlags = this.props.items.map(function (flag) {
            if (flag.name !== "") {
                return (React.createElement("div", { className: "p-filterflag", key: flag.name + "-" + flag.id },
                    React.createElement(player_tag_1.default, { text: flag.name, value: String(flag.id), isCloseable: true, tag: "filter-flag-" + flag.name, onClick: function () { return _this.props.onClose(flag); }, closeTitle: csod.locales.get('Close'), color: "Grey40" })));
            }
        });
        return (React.createElement("div", null,
            listOfFlags,
            " "));
    };
    return FilterFlags;
}(React.Component));
FilterFlags.defaultProps = {
    tag: "",
    items: [],
};
exports.FilterFlags = FilterFlags;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["FilterFlags"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/FilterFlags/FilterFlags.js
// module id = 765
// module chunks = 0